<div class="w-9">
  <p class="title3Font mt-0"
     i18n>Copyright Agreement</p>
</div>

<p-card>
  <div [innerHtml]="copyrightText | safeMessage: 'html'"
       class="et-agreement-block body2Font"></div>
</p-card>

<form [formGroup]="form"
      (ngSubmit)="submitForm()">

  <p-card class="block mt-5">
    <div class="grid px-5">
      <div class="col-4">
        <div class="title4Font mb-5"
             i18n>Choose a type of publishing:</div>
        <div class="field field-radiobutton pb-3">
          <p-radioButton scValidatable
                         name="workOwner"
                         [value]="workOwnerEnum.Author"
                         inputId="author"
                         formControlName="workOwner">
          </p-radioButton>
          <label for="author"
                 class="ml-2 mb-0"
                 i18n>Author’s own work</label>
        </div>
        <div class="field field-radiobutton pb-3">
          <p-radioButton scValidatable
                         name="workOwner"
                         [value]="workOwnerEnum.Government"
                         inputId="government"
                         formControlName="workOwner">
          </p-radioButton>
          <label for="government"
                 class="ml-2 mb-0"
                 i18n>U.S. Government work</label>
        </div>
        <div class="field field-radiobutton pb-3">
          <p-radioButton scValidatable
                         name="workOwner"
                         [value]="workOwnerEnum.HiredEmployee"
                         inputId="hiredEmployee"
                         formControlName="workOwner">
          </p-radioButton>
          <label for="hiredEmployee"
                 class="ml-2 mb-0"
                 i18n>Work made for hire</label>
        </div>
      </div>
      @if (isOrganization) {
        <div class="grid col">
          <p-divider layout="vertical"></p-divider>
          <div class="flex col align-items-center">
            <div class="field flex-grow-1">
              <label for="organization"
                     class="font-bold sc-required-input"
                     i18n>Institution or company (Employer)</label>
              <input scValidatable
                     id="organization"
                     type="text"
                     pInputText
                     formControlName="organization"
                     placeholder="Enter institution or company"
                     i18n-placeholder
                     class="w-full">
            </div>
          </div>
        </div>
      }
    </div>
  </p-card>

  <p-card class="block mt-5">
    <div class="field field-checkbox subtitle3Font mx-5 py-3">
      <p-checkbox scValidatable
                  name="confirmed"
                  formControlName="confirmed"
                  inputId="confirmed"
                  [binary]="true">
      </p-checkbox>
      <label for="confirmed"
             class="ml-2"
             i18n>I confirm that I have been entitled by all authors to sign this Agreement on their
        behalf.</label>
    </div>
  </p-card>

  @if (!isReadonly) {
    <div class="flex justify-content-start mt-5">
      <p-button scSubmitButton
                [requestInProcess]="requestInProcess"
                label="Accept"
                i18n-label></p-button>
    </div>
  }

</form>